/**
 * Operadores de obrigatoriedade condicional por valor, agrupados pelo "tipo de
 * condição" do campo de origem (ver helpers.getConditionKind).
 *
 * - select        -> seleção única e booleano (switchButton)
 * - multiSelect   -> múltipla seleção (resposta é um array)
 * - text          -> texto simples / longo
 * - number        -> numérico
 */
export const OPERATORS_BY_KIND = {
  select: [
    { value: 'filled', label: 'Preenchido' },
    { value: 'eq', label: 'Igual a' },
    { value: 'neq', label: 'Diferente de' }
  ],
  multiSelect: [
    { value: 'filled', label: 'Preenchido' },
    { value: 'contains', label: 'Contém' },
    { value: 'notContains', label: 'Não contém' }
  ],
  text: [
    { value: 'filled', label: 'Preenchido' },
    { value: 'eq', label: 'Igual a' },
    { value: 'neq', label: 'Diferente de' },
    { value: 'contains', label: 'Contém' }
  ],
  number: [
    { value: 'filled', label: 'Preenchido' },
    { value: 'eq', label: 'Igual a' },
    { value: 'neq', label: 'Diferente de' },
    { value: 'gt', label: 'Maior que' },
    { value: 'lt', label: 'Menor que' }
  ]
}

export const DEFAULT_OPERATOR_BY_KIND = {
  select: 'eq',
  multiSelect: 'contains',
  text: 'eq',
  number: 'eq'
}
